export const APP_NAME = "teleDOCTOR";
export const HOST = "https://www.teledoctor.center";
export const LOGIN_URL = HOST + "/rest-auth/login/";
export const FCM_TOKEN_URL = HOST + "/api/account/register/device";
export const NOTIFICATION_URL = HOST + "/api/account/notifs";
export const APPOITMENTS_URL = HOST + "/api/account/appointments";
